import { SystemError } from 'src/app/shared/models/SystemError';

export class ValidationUtils {
    public static isToShowDialogWithUUID(systemError: SystemError): boolean {
        return systemError.errId! < 1009;
    }
}
